import { Plus } from "lucide-react";
import { useTranslation } from "../../hooks/useTranslation";
import { useTheme } from "../../contexts/ThemeContext";

interface AddMoreButtonProps {
  onClick?: () => void;
}

export default function AddMoreButton({ onClick }: AddMoreButtonProps) {
  const { t } = useTranslation();
  const { primaryColor } = useTheme();

  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center gap-2 border border-gray-300 rounded-xl px-3 py-2.5 text-sm text-gray-700 bg-white hover:bg-gray-100 transition rtl"
    >
      <Plus className="w-4 h-4" style={{ color: primaryColor }} />
      <span className="text-[14px] text-black">{t("menu.addMore")}</span>
    </button>
  );
}